<script setup lang="ts">
import BaseForm from "~/components/ui/BaseForm.vue";
import ProgressBar from "~/components/ui/ProgressBar.vue";

defineComponent({
    name: "DefaultFormContainer",
});

const { progress, title } = defineProps({
    progress: { type: Number, required: false },
    title: { type: String, default: "" },
})

const emit = defineEmits(["submit"]);

</script>
<template>
  <BaseForm :title="title" @submit="emit('submit')">
    <template #upper>
        <ProgressBar v-if="progress" :value="progress"/>
        <slot></slot>
    </template>

    <template #bottom>
        <slot name="bottom"></slot>
    </template>

    <template #bottom-out>
        <slot name="bottom-out"></slot>
    </template>
  </BaseForm>
</template>